import classnames from 'classnames'
import React from 'react'

import Button, { BUTTON_SIZE, BUTTON_TYPES } from '../../button'
import Link from '../../link'
import { SiblingProductOptionType } from '../SiblingProductOptions'

import styles from './SiblingProductButton.module.scss'

interface SiblingProductButtonProps {
  value: string
  displayName: string
  isActive: boolean
  variant: SiblingProductOptionType
  onClickCallback?: (val: string) => void
  className?: string
  id?: string
}

function SiblingProductButton({
  variant,
  value,
  displayName,
  isActive,
  onClickCallback,
  className,
  id,
}: SiblingProductButtonProps) {
  return variant === SiblingProductOptionType.LINK ? (
    <Link
      id={id}
      href={value}
      onClick={onClickCallback}
      className={classnames(styles.option, className, isActive && styles.option__selected)}
    >
      {displayName || value}
    </Link>
  ) : (
    <Button
      id={id}
      type={BUTTON_TYPES.OUTLINED}
      size={BUTTON_SIZE.MEDIUM}
      round={false}
      className={classnames(styles.option, className, isActive && styles.option__selected)}
      onClick={() => {
        !isActive && onClickCallback?.(value)
      }}
    >
      {displayName || value}
    </Button>
  )
}

export default SiblingProductButton
